<template>
	<div class="v5-list">
		<slot />
		<div class="v5-list__loading" v-show="loading">
			<slot name="loading">
				<span class="v5-list__loading-text">{{ '加载中' }}</span>
			</slot>
		</div>
		<div class="v5-list__finished" v-show="finished">
			<slot name="finished">
				<span class="v5-list__finished-text">{{ '- 我们是有底线的 -' }}</span>
			</slot>
		</div>
	</div>
</template>
<script>
	import Scroll from '../../mixins/scroll.js';
	export default {
		name: 'v5-list',
		props: {
			value: Boolean,
			finished: Boolean,
			immediateCheck: {
				type: Boolean,
				default: true
			},
			offset: {
				type: Number,
				default: 300
			}
		},
		mixins: [Scroll],
		data() {
			return {
				loading: this.value,
				binded: false
			};
		},
		mounted() {
			this.scroller = this.getScrollEventTarget(this.$el);
			this.handler(true);
			if (this.immediateCheck) {
				this.$nextTick(this.onScroll);
			}
		},
		destroyed() {
			this.handler(false);
		},
		activated() {
			this.handler(true);
		},
		deactivated() {
			this.handler(false);
		},
		watch: {
			value(val) {
				this.loading = val;
			},
			loading(val) {
				this.$emit('input', val);
				this.$nextTick(this.onScroll);
			},
			finished() {
				this.$nextTick(this.onScroll);
			}
		},
		methods: {
			onScroll() {
				if (this.loading || this.finished) {
					this.finished && (this.loading = false);
					return;
				}

				const el = this.$el;
				const {
					scroller
				} = this;
				const scrollerHeight = this.getVisibleHeight(scroller);

				if (!scrollerHeight ||
					this.getComputedStyle(el).display === 'none'
				) {
					return;
				}

				const scrollTop = this.getScrollTop(scroller);
				const targetBottom = scrollTop + scrollerHeight;

				let reachBottom = false;

				if (el === scroller) {
					reachBottom =
						scroller.scrollHeight - targetBottom < this.offset;
				} else {
					const elBottom =
						this.getElementTop(el) -
						this.getElementTop(scroller) +
						this.getVisibleHeight(el);
					reachBottom = elBottom - scrollerHeight < this.offset;
				}
				if (reachBottom) {
					this.loading = true;
					this.$emit('on-load');
				}
			},
			handler(bind) {
				if (this.binded !== bind) {
					this.binded = bind;
					(bind ? this.on : this.off)(
						this.scroller,
						'scroll',
						this.onScroll
					);
				}
			}
		}
	};

</script>
<style lang="scss">
	@import './style.scss';

</style>
